import React from 'react'
import {Link} from 'gatsby'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="Updates:">
        <EuiText>
          <ul>
              <li><Link to="/Frequently_Asked_Question/WQHD_Motion_Detection_Areas/">WQHD Cameras and Motion Detection Areas</Link></li>
              <li><Link to="/Frequently_Asked_Question/WQHD_Motion_Detection_Day_Night_Mode/">Differences between Day and Night Motion Detection Mode</Link></li>
          </ul>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

